export function suggestedStandardComponentId(relatedComponentName, standardComponents, candidates) {
  const standard = standardComponents.find(entry => entry.name === relatedComponentName);
  if (!standard) {
    return 0;
  }
  const matches = candidates.filter(candidate => candidate.standardSurfaceKey === standard.class);
  return matches.length === 1 ? Number(matches[0].id) : 0;
}

export function standardSurfaceKeyOf(rootOptions, componentId) {
  if (typeof rootOptions !== "string") {
    return String(rootOptions?.["standard-surface-key"] ?? "");
  }
  try {
    return String(JSON.parse(rootOptions)?.["standard-surface-key"] ?? "");
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`component ${componentId} has corrupt rootOptions, so it cannot be offered as a standard component`, error);
    return "";
  }
}
